import { render, staticRenderFns } from "./BasicsShelf.vue?vue&type=template&id=6c66952b&scoped=true"
import script from "./BasicsShelf.vue?vue&type=script&lang=js"
export * from "./BasicsShelf.vue?vue&type=script&lang=js"
import style0 from "./BasicsShelf.vue?vue&type=style&index=0&id=6c66952b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66952b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c66952b')) {
      api.createRecord('6c66952b', component.options)
    } else {
      api.reload('6c66952b', component.options)
    }
    module.hot.accept("./BasicsShelf.vue?vue&type=template&id=6c66952b&scoped=true", function () {
      api.rerender('6c66952b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsShelf/BasicsShelf.vue"
export default component.exports